import React, {useState} from 'react';
import {compose, graphql} from 'react-apollo';
import gql from 'graphql-tag';

import {Button, Loading} from 'ui-kit';
import {MemberFields} from '../../../MemberFields';

import * as styles from './AddMember.module.css';

function createNewMember() {
  return {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dobDay: '1',
    dobMonth: '0',
    dobYear: '1990',
  };
}

function AddMember({mutate, membershipId, onSubmit}) {
  const [collapsed, setCollapsed] = useState(true);
  const [member, setMember] = useState(createNewMember());
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    setLoading(true);

    try {
      await mutate({
        variables: {
          input: {
            membershipV2Id: membershipId,
            firstName: member.firstName,
            lastName: member.lastName,
            email: member.email,
            phone: member.phone,
            dateOfBirth: new Date(
              Date.UTC(member.dobYear, member.dobMonth, member.dobDay),
            ).toISOString(),
          },
        },
      });
      setLoading(false);
      setCollapsed(true);
      onSubmit();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  if (collapsed) {
    return (
      <Button color="light" size="small" onClick={() => setCollapsed(false)}>
        + Add a member
      </Button>
    );
  }

  return (
    <form method="post" onSubmit={handleSubmit}>
      <h4 className={styles.Heading}>New member</h4>
      <MemberFields member={member} onChange={setMember} />
      <div className={styles.Footer}>
        <Button type="submit" disabled={loading}>
          {loading ? <Loading immediate /> : 'Save member'}
        </Button>
        <Button
          type="button"
          color="light"
          onClick={() => setCollapsed(true)}
          disabled={loading}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
}

export default compose(
  graphql(
    gql`
      mutation CreateMember($input: CreateMemberV2Input!) {
        createMemberV2(input: $input) {
          errors {
            path
            message
          }
          memberV2 {
            id
          }
        }
      }
    `,
  ),
)(AddMember);
